import React, { createContext } from 'react';
const BaseContext = createContext({});
export { BaseContext };
